import { createSlice } from "@reduxjs/toolkit";
import { myReviewAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const myReviewSlice = createSlice({
  name: "myReview",
  initialState: data,
  reducers: {
    myReviewSlice(state) {
      state.isLoading = false;
    },
    myReviewSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    myReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    myReviewSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const myReviewHandler = () => async (dispatch: any) => {
  try {
    dispatch(myReviewAction.myReviewSlice());
    const response: any = await myReviewAPI();
    dispatch(myReviewAction.myReviewSliceSuccess(response));
  } catch (e: any) {
    dispatch(myReviewAction.myReviewSliceFailure(e?.response?.data?.message));
    dispatch(myReviewAction.myReviewSliceReset());
  }
};
export default myReviewSlice.reducer;
export const myReviewAction = myReviewSlice.actions;
